import { notification } from "antd";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";

import CustomImgUpload from "../../../../Components/Utils/CustomImgUpload";
import axios from "../../../../Services/axiosCommon";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Dasboard from "../../../../Components/Icons/Dasboard";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { CountryMIN } from "../../../../assets/CountryMini";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { NuDate, NuInput, NuLabel, NuMobileNumber, NuSelect, NuSelectwithSearch, NuTextArea, NuUpload, SupplierNuInput } from "../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import useEditFormData from "../../../../Components/Hooks/useEditFormData";
import UseFetchCurrency from "../../../../Components/Hooks/useFetchCurrencyData";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";


const EditSubCon = ({}) => {
  const {officeId} =useParams();

  const { value: desigination } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "desigination_Supplier"
  );
  const { value: vendorRating } = useFetchMetaStar(
    `/dropdown/dropdown-details/`,
    "vendorRating_supplier"
  );
 
  const { value: vendorType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "SupplierType"
  );
  const { value: supplierCat } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "SupplierCategory"
  );
 
  const { value: subConType, getData: refsubConType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "subConType_Supplier"
  );
  const { value: conPeriod, getData: refconPeriod } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "conPeriod_Supplier"
  );
  const [image, setImage] = useState({ preview: "", raw: "" });
  const location = useLocation();
  const data = location.state.data;
  const from = location.state.from;
  console.log(location.state, "state");
  const initialProducts = data?.products
    ? data.products.split(", ").map((p) => p.trim())
    : [];
  const [productList, setProductList] = useState(initialProducts);
  const productsString = productList.join(", ");
  const initialServices = data?.services
    ? data.services.split(", ").map((p) => p.trim())
    : [];
  const [servicesList, setServicesList] = useState(initialServices);
  const servicesString = servicesList.join(", ");
  const initialEmails = data?.emails
    ? data.emails.split(", ").map((p) => p.trim())
    : [];
  const [emailsList, setEmailsList] = useState(initialEmails);
  const emailsString = emailsList.join(", ");
  const { Oncancel, editFormData, contextHolder, isLoading } =
    useEditFormData();
  const [createNew, setCreateNew] = useState({
    contactPerson: data?.contactPerson,
    companyName: data?.companyName,
    email: data?.email,
    phone: data?.phone,
    countryCode: data?.phoneCC,
    website: data?.website,
    designation: data?.designation,
    buildingNo: data?.buildingNo,
    contactPersonEmail: data?.contactPersonEmail,
    contactPersonMobile: data?.cPMobile,
    taxId: data?.taxId,
    performanceRating: data?.performanceRating,
    comments: data?.comments,
    streetName: data?.streetName,
    country: data?.country,
    city: data?.city,
    state: data?.state,
    district: data?.district,
    postalCode: data?.postalCode,
      cpCountryCode: data?.cPMobileCC,
      scStatus: data?.scStatus,

    
    address1: data.address1,
    address2: data.address2,
    category: data.category,
   
       branchId:officeId,
    
    
    subConType:data.subConType,
    subConNumber: data.subConNumber,
    title:data.title,
    scopeOfWork:data.scopeOfWork,
    conName:data.conName,
    signedOn:data.signedOn,
    conValue:data.conValue,
    conPeriod: data.conPeriod,
    startDate:data.startDate,
    endDate:data.endDate,
    renewedOn:data.renewedOn,
    renewable:data.renewable, //true
    validUpto:data.validUpto,
    terminationDate:data.terminationDate,
    terminationReason:data.terminationReason,
    amendmendRef:data.amendmendRef,
    amendmendValue: data.amendmendValue,
    totalConValue:data.totalConValue,

  });
  const handleChangeImg = (e) => {
    if (e.target.files.length) {
      setImage({
        preview: URL.createObjectURL(e.target.files[0]),
        raw: e.target.files[0],
      });
    }
  };
  // const handleChange = (event) => {
  //   const { value } = event.target;
  //   console.log("ss", typeof(value));
  //   let boolValue = (value === "true")
  //   console.log("test",boolValue);
    
  //   formik.setFieldValue("isGeneral", boolValue);
  // };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      phone: yup
        .string()
        .matches(/^\d+$/, "Phone number must contain only digits")
        .min(9, "Phone number must be at least 9 digits")
        .max(11, "Phone number must be at most 11 digits")
        .required("Phone number is required"),
      contactPersonMobile: yup
        .string()
        .matches(/^\d+$/, "Phone number must contain only digits")
        .min(9, "Phone number must be at least 9 digits")
        .max(11, "Phone number must be at most 11 digits")
        .required("Contact Phone number is required"),
      email: yup.string().required("Email is required!"),
      companyName: yup.string().required("Company Name is required!"),
      // website: yup.string().required("Website is required!"),
      contactPerson: yup.string().required("Contact Person is required!"),
    }),
    onSubmit: async (value, { resetForm }) => {
      // setLoading(true);
      let formData = new FormData();
      const valueWithProducts = {
        ...value,
        renewable: value.renewable === "true",
       
       
      };
      formData.append("json_data", JSON.stringify(valueWithProducts));
      formData.append("attachments", image.raw);

      editFormData(
        `/sub-con/${data.id}`,
        formData,
        resetForm,
        from
      );
      // setLoading(false);
    },
  });
  const handleAddProducts = () => {
    const newProducts = formik.values.products
      .split(",")
      .map((p) => p.trim())
      .filter(Boolean);
    setProductList((prevList) => {
      const allProducts = [...prevList, ...newProducts];
      return Array.from(new Set(allProducts)); // Ensure unique products
    });
    formik.setFieldValue("products", "");
  };

  const handleDeleteProduct = (index) => {
    setProductList((prevList) => prevList.filter((_, i) => i !== index));
  };

  const handleAddServices = () => {
    const newServices = formik.values.services
      .split(",")
      .map((p) => p.trim())
      .filter(Boolean);
    setServicesList((prevList) => {
      const allServices = [...prevList, ...newServices];
      return Array.from(new Set(allServices)); // Ensure unique products
    });
    formik.setFieldValue("services", "");
  };

  const handleDeleteServices = (index) => {
    setServicesList((prevList) => prevList.filter((_, i) => i !== index));
  };

  const handleAddEmails = () => {
    const newEmails = formik.values.emails
      .split(",")
      .map((p) => p.trim())
      .filter(Boolean);
    setEmailsList((prevList) => {
      const allEmails = [...prevList, ...newEmails];
      return Array.from(new Set(allEmails)); // Ensure unique products
    });
    formik.setFieldValue("emails", "");
  };

  const handleDeleteEmails = (index) => {
    setEmailsList((prevList) => prevList.filter((_, i) => i !== index));
  };


  
  

  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-end mb-4">
        {/* <Breadcrumb
          items={[
            {
              name: "Suppliers",
              link: `/main/${officeId}/contacts/suppliers`,
            },
            {
              name: "Edit ",
            },
          ]}
        /> */}
        <BackButton />
      </div>
      <div className="w-full h-[calc(100vh-140px)] overflow-y-auto">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full mx-auto pb-4 bg-white rounded-md  ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
              <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Company Details
                </p>
              </div>
              <NuInput
                type="text"
                label="Company Name"
                placeholder="company Name"
                formik={formik}
                name="companyName"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Category"
                placeholder="Choose"
                Options={supplierCat}
                formik={formik}
                name="category"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              

              <NuMobileNumber
                nunCode="countryCode"
                label="Phone"
                placeholder="Phone"
                formik={formik}
                name="phone"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="email"
                label="Email"
                placeholder="Email"
                formik={formik}
                name="email"
                width="w-full md:w-1/2 lg:w-1/3"
                isRequired={true}
              />

              <NuInput
                type="text"
                label="Website"
                placeholder="Website"
                formik={formik}
                name="website"
                // isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />
     
              <NuInput
                type="number"
                label="Tax Id"
                placeholder="Tax Id"
                formik={formik}
                name="taxId"
                width="w-full md:w-1/2 lg:w-1/3"
              />

             
              <FormikSelectTwo
                Options={vendorRating}
                label="Performance Ratings"
                placeholder="Performance Ratings"
                formik={formik}
                name="performanceRating"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuUpload
                label=" Image"
                width="w-full md:w-1/2 lg:w-1/3"
                onChange={handleChangeImg}
              />

                            <FormikSelectTwo
                label="Status"
                placeholder="Choose"
                Options={[
                  {value:'Active',label:'Active'},
                  {value:'Inactive',label:'In-Active'},

                ]}
                formik={formik}
                name="scStatus"
                width="w-full md:w-1/2 lg:w-1/3"
               
              />
 <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                Sub-Contractor Details :
                </p>
              </div>
              <NuInput
                type="text"
                label="Title"
                placeholder="Title"
                formik={formik}
                name="title"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <NuInput
                type="text"
                label="Contractor Name"
                placeholder="Contractor Name"
                formik={formik}
                name="conName"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <NuInput
                type="number"
                label="Sub-Con Number"
                placeholder="Sub-Con Number"
                formik={formik}
                name="subConNumber"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <DropDownAddMetaData
                label="Sub-Con Type"
                placeholder="Choose"
                Options={subConType}
                formik={formik}
                name="subConType"
                width="w-full md:w-1/2 lg:w-1/3"
               
              />
               <NuDate
                            label="Signed On"
                            placeholder="signed On"
                            formik={formik}
                            name="signedOn"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                          <NuInput
                type="number"
                label="Value"
                placeholder="Value"
                formik={formik}
                name="conValue"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <DropDownAddMetaData
                label="Sub-Con Period"
                placeholder="Choose"
                Options={conPeriod}
                formik={formik}
                name="conPeriod"
                width="w-full md:w-1/2 lg:w-1/3"
               
              />
               <NuDate
                            label="Start Date"
                            placeholder="Start Date"
                            formik={formik}
                            name="startDate"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                           <NuDate
                            label="End Date"
                            placeholder="End Date"
                            formik={formik}
                            name="endDate"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                           <NuDate
                            label="Renewed On"
                            placeholder="Renewed On"
                            formik={formik}
                            name="renewedOn"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                          <FormikSelectTwo
                type="text"
                label="Renewable"
                placeholder="Choose"
                Options={[
                  {
                    value:'true',label:'True'
                  },
                  {
                    value:'false',label:'False'
                  }
                ]}
                formik={formik}
                name="renewable"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <NuDate
                            label="Valid Upto"
                            placeholder="Valid Upto"
                            formik={formik}
                            name="validUpto"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                           <NuDate
                            label="Termination Date"
                            placeholder="Termination Date"
                            formik={formik}
                            name="terminationDate"
                            width="w-full md:w-1/2 lg:w-1/3"
                          />
                          <NuInput
                type="text"
                label="Amendmend Reference"
                placeholder="Amendmend Reference"
                formik={formik}                
                name="amendmendRef"
                width="w-full md:w-1/2 lg:w-1/3"
              />
               <NuInput
                type="number"
                label="Amendmend Value"
                placeholder="Amendmend Value"
                formik={formik}
                name="amendmendValue"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="number"
                label="Total-Con Value"
                placeholder="Total-Con Value"
                formik={formik}
                name="totalConValue"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                  Contact Person Details :
                </p>
              </div>

              <NuInput
                type="text"
                label="Name"
                placeholder="Name"
                formik={formik}
                name="contactPerson"
                isRequired={true}
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Designation"
                placeholder="Choose"
                Options={desigination}
                formik={formik}
                name="designation"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuMobileNumber
                nunCode="cpCountryCode"
                label="Contact Person Mobile"
                placeholder="Contact Person Mobile"
                formik={formik}
                isRequired={true}
                name="contactPersonMobile"
                width="w-full md:w-1/2 lg:w-1/3"
              />
              <NuInput
                type="email"
                label="Contact Person Email"
                placeholder="Contact Person Email"
                formik={formik}
                name="contactPersonEmail"
                width="w-full md:w-1/2 lg:w-1/3"
              />
            </div>
          </div>
          <div className="w-full mx-auto pb-4 bg-white rounded-md  mt-4">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
              <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                  Address :
                </p>
              </div>

              <NuInput
                type="text"
                label="Street Address Line 1"
                placeholder="Street Address Line 1"
                formik={formik}
                name="address1"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="Street Address Line 2"
                placeholder="Street Address Line 2"
                formik={formik}
                name="address2"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="City"
                placeholder="City"
                formik={formik}
                name="city"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="text"
                label="State / Province"
                placeholder="State / Province"
                formik={formik}
                name="state"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <NuInput
                type="number"
                label="Postal / Zip Code"
                placeholder="Postal / Zip Code"
                formik={formik}
                name="postalCode"
                width="w-full md:w-1/2 lg:w-1/3"
              />

              <FormikSelectTwo
                type="text"
                label="Country"
                placeholder="Country"
                Options={CountryMIN}
                formik={formik}
                name="country"
                width="w-full md:w-1/2 lg:w-1/3"
                FixPosition={false}
                PortalTarget={false}
              />
 <NuTextArea
                label="Scope of Work"
                placeholder="Scope of Work"
                formik={formik}
                name="scopeOfWork"
                width="w-full md:w-1/2 "
                // new_width="lg:w-1/2"
              />
              <NuTextArea
                label="Comments"
                placeholder="comments"
                formik={formik}
                name="comments"
                width="w-full md:w-1/2 "
                // new_width="lg:w-2/3"
              />
             

              <div className="w-full hidden md:block mx-auto my-4 mt-8 ">
                <div className="md:flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
export default EditSubCon;
